import React, { useState, useEffect } from "react";
import SelectClass from "components/SelectClass";
import { Link } from "react-router-dom";
import Modal from "components/Modal";
import ReactPlayer from "react-player-linkorn-ruvideo";
import { IPriceClass } from "types/product";
import { Actions as cartActions, IAddCartProduct } from "reducers/cart";
import { IRootState } from "reducers";
import { connect } from "react-redux";
import { count } from "rxjs/operators";
import cn from "classnames";
import { getRefBonus } from "reducers/user";
import {
  normalizePrice,
  getPrice,
  getBonus,
} from "utils/helpers";

export interface ICardProps {
  description: string;
  name: string;
  category?: string;
  price: number;
  market_price: number;
  id: number;
  video?: string;
  product_price_classes: IPriceClass[];
  image: string;
  price_top: boolean;
  addOrUpdateToCart: (payload: IAddCartProduct) => void;
  agent_fee_pct: number;
  top_discount_pct: number;
  top_agent_fee_pct: number;
  defaultClassId?: number;
  refBonus: number;
  agent_fee_rub: number;
}

interface IModal {
  type: string;
  data?: string;
}

const CardProduct: React.FC<ICardProps> = ({
  id,
  name,
  product_price_classes,
  video,
  image,
  addOrUpdateToCart,
  price_top,
  defaultClassId,
  top_discount_pct = 0,
  agent_fee_pct = 0,
  top_agent_fee_pct = 0,
  refBonus = 0,
  agent_fee_rub = 0,
}) => {
  const [modal, showModal] = useState<IModal | undefined>(undefined);

  const hideModal = () => showModal(undefined);

  const defaultClass = defaultClassId
    ? product_price_classes.find(i => i.car_class_id === defaultClassId)
    : undefined;
  const [selectedOption, setSelectedOption] = useState(
    defaultClass || product_price_classes[0]
  );

  useEffect(
    () => {
      const newClass = defaultClassId
        ? product_price_classes.find(i => i.car_class_id === defaultClassId)
        : undefined;
      setSelectedOption(newClass || product_price_classes[0]);
    },
    [defaultClassId]
  );

  const handleChangeClass = (value: IPriceClass) => {
    setSelectedOption(value);
  };

  // Цена
  const price = getPrice(selectedOption.price, top_discount_pct);

  // Бонус агенту
  const bonus = getBonus(
    price,
    agent_fee_pct,
    agent_fee_rub,
    top_agent_fee_pct,
    refBonus,
  );

  return (
    <React.Fragment>
      <div className={cn("card cards", { "no-top-price": !price_top })}>
        <div className="cards__video text-right">
          {video && (
            <div>
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20.8391 10.5333C20.8391 15.7949 16.5566 20.0667 11.2658 20.0667C5.97495 20.0667 1.69238 15.7949 1.69238 10.5333C1.69238 5.27179 5.97495 1 11.2658 1C16.5566 1 20.8391 5.27179 20.8391 10.5333Z"
                  fill="#FFD800"
                  fillOpacity="0.75"
                  stroke="white"
                  strokeWidth="2"
                />
                <path
                  d="M7.8252 5.69043V15.6039L16.5382 10.7614L7.8252 5.69043Z"
                  fill="white"
                />
              </svg>
              <a
                onClick={() => showModal({ type: "showImage", data: video })}
                className="reg__clean d-inline"
              >
                Видео
              </a>
            </div>
          )}
        </div>
        <Link to={`/home/card/${id}`}>
          <div className="cards__img text-center">
            <img src={image} alt="" />
          </div>
          <div className="cards__desc">
            <h3 className="cards__desc-title">{name}</h3>
          </div>
        </Link>
        <div>
          <div className="card-price__label">
            {selectedOption && selectedOption.car_class_id !== 0 && (
              <span className="card__comment-span card__class-label">
                Класс:
              </span>
            )}
            <div className="row no-gutters justify-content-between card-price__market-price">
              <span className="card__comment-span large-screen">
                Рыночная цена:
              </span>
              <span className="card__comment-span small-screen">
                Рын. цена:
              </span>
              <span className="card__comment-span">
                {selectedOption.market_price}₽
              </span>
            </div>
          </div>
          <div className="row no-gutters justify-content-between card-price__price-block">
            {selectedOption && selectedOption.car_class_id !== 0 && (
              <SelectClass
                value={selectedOption}
                options={product_price_classes}
                onChange={handleChangeClass}
              />
            )}
            <div className="cards__price">
              <button
                className="cards__price-btn btn px-0 py-0 text-left"
                onClick={() =>
                  addOrUpdateToCart({
                    product_id: id,
                    car_classes_id: selectedOption.car_class_id,
                    quantity: 1
                  })
                }
              >
                {normalizePrice(price)} ₽
              </button>
            </div>
          </div>
          <div className="cards__bonus">
            <div className="row no-gutters justify-content-between align-items-end">
              <p className="mb-0">Ваш бонус:</p>
              <strong className="float-right">{normalizePrice(bonus)} ₽</strong>
            </div>
          </div>
        </div>
      </div>

      {/* Modals */}
      {/* Показ с картинкой */}
      {modal && modal.type === "showImage" && modal.data && (
        <Modal onClose={hideModal}>
          <div className="modal-video-container">
            <ReactPlayer
              controls={true}
              url={modal.data}
              playing={false}
              width={"100%"}
              height={"100%"}
            />
          </div>
          <div className="text-center px-4 px-md-0">
            <button
              onClick={hideModal}
              className="btn btn-primary btn-style"
              data-dismiss="modal"
              aria-label="Close"
            >
              Закрыть
            </button>
          </div>
        </Modal>
      )}
    </React.Fragment>
  );
};

const mapStateToProps = ({ user }: IRootState) => ({
  refBonus: getRefBonus(user)
});

const actions = {
  addOrUpdateToCart: cartActions.addOrUpdateToCart
};

export default connect(
  mapStateToProps,
  actions
)(CardProduct);
